import { BaseManagementApi } from './api.base';

export class CloudManagementApi extends BaseManagementApi {
}
